import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import EllipsisTitle from '../../portal/ellipsisTitle';
import TeamManageMenu from '../teamManageMenu';
import SortTeams from '../sortTeams';

@inject('translationsStore', 'teamsStore', 'usersStore') @observer
export default class AddTeam extends Component {
    constructor(props){
        super(props);
    };

    state = {
        open: false
    }

    open = () => {
        
        this.setState({
            open: true
        });
    }

    getTeamNumberTitle(){

        let teamsNumber = '';

        if(this.props.teamsStore.teamsNumber > 0)
        {
            teamsNumber = `${this.props.teamsStore.teamsNumber} ${this.props.translationsStore.translate('TEAMS')}`;
            
            if(this.props.teamsStore.teamsNumber != this.props.teamsStore.displayedTeamsNumber){
                teamsNumber = `${this.props.teamsStore.displayedTeamsNumber}/${teamsNumber}`;
            }
            
            teamsNumber = `(${teamsNumber})`;
        }

        return `${this.props.translationsStore.translate('HIERARCHY')} ${teamsNumber}`;
    }

    render(){

        const title = this.getTeamNumberTitle();

        return(
            <div className='edit-teams-wrapper' data-cy='edit-teams-wrapper'>
                <EllipsisTitle width='85%' title={title} />
                {/* add my component here and send set state function inside it */}
                <SortTeams setSortFunction={this.props.setSortFunction} />
                <TeamManageMenu disableTeamMenu={this.props.disableTeamMenu} />
            </div>
        );
    }
}
